export default __webpack_public_path__ + "static/media/2.25df07ca.webp";